@if (this.sidenavService.sidenavState$ | async; as sidenavState) {
  @if (sidenavState.state.isVisible) {
    <aside
          [ngClass]="{
             'md:flex flex-col justify-between h-screen min-h-screen py-4 px-4 transition-all bg-th-sidenav-background': true,
             'border-r shadow-sm flex border-th-line print:hidden overflow-x-hidden': true,
             'hidden w-20 lg:w-60 sticky top-0 overflow-auto z-auto': !sidenavState.state.isOverlay,
             'overlay overflow-visible fixed inset-y-0 left-0 max-w-full z-50 w-60': sidenavState.state.isOverlay
          }">
      @for (component of sidenavState.components; track component) {
        <pa-sidenav-content
          [component]="component">
        </pa-sidenav-content>
      }
    </aside>
  }
}
